import { Component, OnInit } from '@angular/core';
import * as d3 from 'd3';
import { ForceLink } from 'd3-force/src/index';
import $ from "jquery";
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Message } from 'src/app/models/message';
import { Tier1 } from 'src/app/models/obs/tier1';
import { Tier3 } from 'src/app/models/obs/tier3';
import { MegatrendsRelationsService } from 'src/app/services/obs/megatrends-relations.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { Tier1Service } from 'src/app/services/obs/tier1.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';


@Component({
  selector: 'app-forcemap',
  templateUrl: './forcemap.component.html',
  styleUrl: './forcemap.component.scss'
})
export class ForcemapComponent implements OnInit {

  globalTrends: Tier3[];
  megaTrends: Tier3[];
  tematicas: any[];
  msg: Message;/* id Tendencias globales */
  idGlobalTrends: number = 11;
  idMegatrends: number = 7;
  tier1: Tier1 = {};

  dataNodos: any = [];

  dataLinksNcNe: any = [];

  constructor(
    private tier1S: Tier1Service,
    private mtrService: MegatrendsRelationsService,
    private t3Service: Tier3Service,
    private tematicService: TematicService
  ) { }

  ngOnInit() {
    this.getDataLinksNcNe();
    this.getDataNodos();
    this.getOneTier1();
  }

  getOneTier1() {
    this.tier1S.getOne(29).subscribe({
      next: res => {
        this.tier1 = res['data'];
      },
      error: err => console.error(err)
    });
  }

  getDataLinksNcNe() {
    this.mtrService.getAll().subscribe({
      next: res => {
        this.dataLinksNcNe = res['data'];
      },
      error: err => { }
    })
  }

  getDataNodos() {
    const globalTrendsObs = this.getTrendsByIdTier1(this.idGlobalTrends, "1", this.dataNodos);
    const megaTrendsObs = this.getTrendsByIdTier1(this.idMegatrends, "0", this.dataNodos);
    const tematicsObs = this.getTematics();

    forkJoin([globalTrendsObs, megaTrendsObs, tematicsObs]).subscribe({
      next: ([globalTrends, megaTrends, tematics]) => {
        this.draw();
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  getTrendsByIdTier1(id: number, level: string, targetArray: any[]): Observable<any> {
    return this.t3Service.getByIdTier1(id).pipe(
      map(res => {
        const trends = res['data'].map((trend: Tier3) => {
          return {
            id: trend.code,
            name: trend.shorttitle,
            nameLg: trend.longtitle,
            abst: trend.summary,
            group: level,
            level: trend.idtematic
          };
        });
        targetArray.push(...trends);
        return trends;
      }),
      catchError(err => {
        this.msg = err;
        return of([]);
      })
    );
  }

  getTematics(): Observable<any> {
    return this.tematicService.getAll().pipe(
      map(res => {
        this.tematicas = res['data'].map(tematic => ({
          level: tematic.id.toString(),
          name: tematic.title,
          nameTipo: tematic.title,
          color: tematic.color,
        }));
        /* console.log("ematicas en getTematics: ", this.tematicas); */
        return this.tematicas;
      }),
      catchError(err => {
        this.msg = err;
        return of([]);
      })
    );
  }

  draw() {
    let self = this;
    var svg = d3.select('#mapa').append('svg')
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .attr('viewBox', "0 0 700 800")
      .attr('id', "svg")
      .attr('preserveAspectRatio', "xMidYMin slice");

    var detalle = d3.select('#detalle');
    var descripcion = d3.select('#descripcion');
    var nodo_selec = d3.select('#nodo_selec');
    var titulo_nodo = d3.select('#titulo_nodo');
    var resumen_nodo = d3.select('#resumen_nodo');
    var subtitulo = d3.select('#subtitulo');
    var relacionados = d3.select('#relacionados');
    var ficha = d3.select('#ficha');
    var btnFicha = d3.select('#btnFicha');

    var radius: number = 300;
    var width = (radius * 2) + 100;
    var height = width;

    /*     Puntos cartesianos de las formas de los nodos  */
    var pointsNE = "-10,-15 50,0 -10,15 -30,0";
    var pointsNC = "-11,9 0,-9 11,9 0,5";

    function simulador(data) {      
      var arrayNE = []; // array de cantidad de relaciones de nodos externos
      var arrayNC = []; // array de cantidad de relaciones de nodos centrales
      var listaFuertes = []; // nodos con relacion fuerte
      var listaModerados = []; // nodos con relacion moderada

      asignarAtributos();

      var click = 0; //contador de click

      var isNodeSelected = false;

      const manyBody = d3.forceManyBody().strength(-5); // fuerza de atracción entre nodos
      const center = d3.forceCenter().x((width / 2)).y((height / 2)); // fuerza de atracción al centro

      // define force
      let simulation = d3.forceSimulation<any, any>()
        .force('link', d3.forceLink().id(function (link: any) { return link.id; })
          .strength(0))
        .force('charge', manyBody)
        .force('center', center)
        .nodes(data)
        .on('tick', changeNetwork); // actualiza la gráfica mediante una animación

      createNodoExt(280);

      var dragDrop = d3.drag()
        .on('start', function (node: any) {          
          node.fx = node.x
          node.fy = node.y
        })
        .on('drag', function (node: any) {
          simulation.alphaTarget(0).restart()
          node.fx = node.x
          node.fy = node.y
        })
        .on('end', function (node: any) {
          if (!node.active) {
            simulation.alphaTarget(0)
          }
          node.fx = null
          node.fy = null
        });

      var lineasNcNe = svg.selectAll("linesNcNe")
        .data(self.dataLinksNcNe)
        .enter().append("line")
        .attr("class", "linesNcNe")
        .attr("id", function (link: any) { return link.target + "_" + link.source })
        .attr("stroke-width", function (link: any) {
          return link.relation == 2 ? 0.1 :
            link.relation == 3 ? 0.2 :
              link.relation == 4 ? 0.6 : null;
        })
        .attr("fill", "none")
        .attr("stroke", function (link: any) {
          var color;
          self.dataNodos.forEach(function (obj: any) {
            if (obj.id == link.target) {
              color = obj.color;
            }
          })
          return color;
        })
        .style("stroke-opacity", function (link: any) {
          return link.relation < 4 ? 0.3 : 1;
        });

      var nodos = svg.selectAll('figNC')
        .data(data)
        .enter().append("polygon")
        .attr("class", "figNC")
        .attr("id", function (node: any) { return node.id; })
        .attr('points', function (node: any) {
          return node.group == 0 ? pointsNE
            : pointsNC
        })
        .attr('stroke', "white")
        .attr('cursor', "pointer")
        .attr('stroke-width', 5)
        .attr('paint-order', 'stroke')
        .attr('stroke-linejoin', 'miter-clip')
        .attr("fill", function (node: any) { return node.color; })
        .call(dragDrop)
        .on('click', fade(.15))
      //.each(tooltip.events);

      var textoNodos = svg.selectAll("textNodos")
        .data(data)
        .enter().append("text")
        .attr("class", "textNodos")
        .text(function (node: any) { return node.name })
        .attr("font-size", function (node: any) { return node.group == 0 ? 11 : node.tam * 11; })
        .style('visibility', textoConfInicial)
        .attr("text-anchor", "middle")
        .attr('stroke', "white")
        .attr('stroke-width', 4)
        .attr('paint-order', 'stroke')
        .attr('stroke-linejoin', 'round')
        .attr('cursor', "pointer")
        .call(dragDrop)
        .on('click', fade(.15))
        .attr('dx', 0)
        .attr("dy", 15);
      //.call(wrap);

      var imgs = svg.selectAll("image").data([0]);
      imgs.enter()
        .append("svg:image")
        .attr("xlink:href", "assets/img/logo.png")
        .attr("x", "40")
        .attr("y", "620")
        .attr("width", "10%")
        .attr("height", "10%");

      var sub = svg.selectAll('subPrincipal')
        .data([0])
        .enter()
        .append("text")
        .attr("class", "subPrincipal")
        .attr("x", 10)
        .attr("y", 20)
        .text("¿Qué tendencias están más relacionadas con las megatendencias?")
        .attr("font-size", "16px")
        .attr('stroke', "white")
        .attr('stroke-width', 4)
        .attr('paint-order', 'stroke');

      //this.svg.call(tooltip);

      simulation.force<ForceLink<any, any>>("link").links(self.dataLinksNcNe);

      svg.on('click', function () {
        if (!isNodeSelected) {
          resetOpacity();
        } else {
          isNodeSelected = false;
        }
      });

      function createNodoExt(radius) {
        var megas = [],
          angle,
          x,
          y,
          i,
          j = 0,
          cmt = 0;

        for (i = 0; i < data.length; i++) {
          if (data[i].group == 0) {
            cmt++;
          }
        }

        for (i = 0; i < data.length; i++) {
          if (data[i].group == 0) {
            angle = (j / (cmt / 2)) * Math.PI;
            x = (radius * Math.cos(angle)) + (width / 2);
            y = (radius * Math.sin(angle)) + (height / 2);
            data[i].fx = x;
            data[i].x = x;
            data[i].fy = y;
            data[i].y = y;
            data[i].angle = angle * 180 / Math.PI;
            j++;
          }
        }
      }

      function changeNetwork() {
        nodos
          .attr('transform', function (node: any) {
            return node.group == 1 ?
              'translate(' + node.x + ',' + node.y + ') scale(' + node.tam + ')' :
              'translate(' + node.x + ',' + node.y + ') rotate(' + node.angle + ',0,0) scale(' + node.tam + ')'
          });
        textoNodos
          .attr('x', function (node: any) { return node.x })
          .attr('y', function (node: any) {
            if (node.group == 0 && node.x > radius) {
              return node.y - 14;
            } else {
              return node.y;
            }
          });
        lineasNcNe
          .attr('x1', function (link: any) { return link.source.x })
          .attr('y1', function (link: any) { return link.source.y })
          .attr('x2', function (link: any) { return link.target.x })
          .attr('y2', function (link: any) { return link.target.y });
      };

      function fade(opacity) {
        return function (event ,d) {          
          sub.text(function () {
            return d.group == 0
              ? "¿Qué tendencias están más relacionadas con la megatendencia " + d.name.toLowerCase() + "?"
              : "¿Qué megatendencias están más relacionadas con la tendencia " + d.name.toLowerCase() + "?";
          })
            .call(wrap);
          $("#descripcion").hide();
          nodo_selec.attr('class', 'subtitulo2')
            .text(function (o) {
              return d.group == 0 ? "Megatendencia seleccionada" : "Tendencia seleccionada";
            });

          $("#detalle").hide();
          $("#detalle").show(600);
          titulo_nodo.html(d.nameLg)
            .attr('style', "height:auto");

          isNodeSelected = true;
          mostrarRelacionados(d);

          var relationsNC = getRelationsNC(d);
          nodos.transition()
            .duration(700)
            .style("stroke-opacity", function (o: any) {
              var thisOpacity = isConnected(d, o) ? 1 : opacity;
              this.setAttribute('fill-opacity', thisOpacity);
              return thisOpacity;
            })
            .attr('stroke', function (o: any) {
              return d.id == o.id ? 'black' : 'white';
            });

          var temp = opacity;
          if (opacity != 1) { opacity = 0; }

          lineasNcNe.transition()
            .duration(500)
            .attr("stroke-dashoffset", 1)
            .style("stroke-opacity", function (o: any) {
              return o.source == d || o.target == d ? 1 : opacity;
            })
            .attr("stroke-width", function (link: any) {
              return link.relation == 2 ? 0.4 :
                link.relation == 3 ? 0.8 :
                  link.relation == 4 ? 1.5 : null;
            });

          textoNodos.transition()
            .duration(500)
            .style("visibility", function (o: any) {
              var thisOpacity = isConnected(d, o) ? 'visible' : 'hidden';
              return thisOpacity;
            })
            /*.attr('font-size',12);*/
            .attr('font-size', function (p: any) {
              if (d.group == 0) {
                return d.id == p.id ? 12 : 11 * p.tam;
              } else {
                var t_tem = 0;
                relationsNC.forEach(function (link) {
                  if (p.id == link.source) {
                    t_tem = link.relation;
                  }
                })
                return t_tem == 4 ? 13 :
                  t_tem == 3 ? 10 :
                    t_tem == 2 ? 9 : null;
              }
            });
          opacity = temp;
        };
      };

      function getRelationsNC(node) {
        var temp_rel = [];
        var i = 0;
        self.dataLinksNcNe.forEach((link: any) => {
          if (link.target.id == node.id) {
            temp_rel.push({ "source": link.source.id, "relation": link.relation });
          }
        });
        return temp_rel;
      }

      function resetOpacity() {
        $("#detalle").hide();
        $("#descripcion").show(600);
        titulo_nodo.text('');
        resumen_nodo.text('');
        sub.text("¿Qué tendencias están más relacionadas con las megatendencias?");
        var opacity = 1;
        nodos.style("stroke-opacity", opacity)
          .transition()
          .duration(700)
          .attr('fill-opacity', opacity)
          .attr('stroke', 'white');

        lineasNcNe.transition()
          .duration(500)
          .delay(300)
          .attr("stroke-dashoffset", 0)
          .style("stroke-opacity", function (link: any) {
            return link.relation < 4 ? 0.4 : 1; // Si no son fuertes
          })
          .attr("stroke-width", function (link: any) {
            return link.relation == 2 ? 0.1 :
              link.relation == 3 ? 0.2 :
                link.relation == 4 ? 0.6 : null;
          });

        textoNodos.transition()
          .duration(700)
          .style("visibility", textoConfInicial)
          .attr("font-size", function (node: any) { return node.group == 0 ? 11 : node.tam * 11; });
      }

      function textoConfInicial(d) {
        return d.tam < 1 && d.group != 0 ? "hidden" : "visible";
      }

      function exitSimuladores() {
        nodos.exit().remove();
        lineasNcNe.exit().remove();
        textoNodos.exit().remove();
      }

      function getFuertes(node) {
        clearArray(listaFuertes);
        clearArray(listaModerados);
        self.dataLinksNcNe.reduce(function (fuertes, link) {
          if (link.relation == 4) {
            if (link.target.id == node.id) {
              listaFuertes.push(link.source.id);
            } else if (link.source.id == node.id) {
              listaFuertes.push(link.target.id);
            }
          }
          if (link.relation == 3) {
            if (link.target.id == node.id) {
              listaModerados.push(link.source.id);
            } else if (link.source.id == node.id) {
              listaModerados.push(link.target.id);
            }
          }
        }, [node.id])
      }

      function isConnected(a, b) {
        return linkedByIndex[a.index + "," + b.index] || linkedByIndex[b.index + "," + a.index] || a.index == b.index;
      };

      var linkedByIndex = {};

      self.dataLinksNcNe.forEach(function (d) {
        linkedByIndex[d.target.index + "," + d.source.index] = 1;
      });

      function contarRelaciones() {
        clearArray(arrayNE);
        clearArray(arrayNC);
        self.dataNodos.forEach((data) => {
          var cont = 0;
          self.dataLinksNcNe.forEach((link) => {
            if (data.id == link.target || data.id == link.source) {
              cont++;
            }
          })
          data.rel = cont;
          if (data.group == 0) { arrayNE.push(cont); } else { arrayNC.push(cont); }
        })
      }

      function asignarAtributos() {
        contarRelaciones();
        var maxM = Math.max.apply(null, arrayNE);
        var minM = Math.min.apply(null, arrayNE);
        var maxR = Math.max.apply(null, arrayNC);
        var minR = Math.min.apply(null, arrayNC);

        self.dataNodos.forEach((d) => {
          //  Color y nameTipo
          self.tematicas.forEach(function (e) {
            if (d.level == e.level) {
              d.color = e.color;
              d.nameTipo = e.nameTipo;
            }
          })

          //  Tamaño de nodos            
          if (d.group == 0) {
            var rangeM = (maxM - minM) / 3;
            if (d.rel <= (rangeM + minM)) { d.tam = 0.7; } else
              if (d.rel <= (2 * rangeM + minM)) { d.tam = 0.9; } else { d.tam = 1.2 };
          } else if (d.group == 1) {
            var rangeR = (maxR - minR) / 3;
            if (d.rel <= (rangeR + minR)) { d.tam = 0.5; } else
              if (d.rel <= (2 * rangeR + minR)) { d.tam = 0.8; } else { d.tam = 1; }
          }
        })
      }

      function mostrarRelacionados(d) {
        var band = 0; // bandera: fuertes o moderados
        getFuertes(d);
        var listaHTML = "";
        if (isValidArray(listaFuertes) || isValidArray(listaModerados)) {
          //listaFuertes.shift(); // Quita el primero            
          if (listaFuertes.length > 0) {
            listaFuertes.forEach(function (o) {
              self.dataNodos.forEach(function (p) {
                if (o == p.id) {
                  listaHTML += "<li><a class='underline' href='../ficha/" + p.id + "'>" + p.name + "</a></li>";
                }
              })
            })
            band = 0;
          } else if (listaFuertes.length == 0) {
            listaModerados.forEach(function (o) {
              self.dataNodos.forEach(function (p) {
                if (o == p.id) {
                  listaHTML += "<li><a class='underline' href='../ficha/" + p.id + "'>" + p.name + "</a></li>";
                }
              })
            })
            band = 1;
          }

          if (band == 0) {
            resumen_nodo.html(function () {
              if (listaFuertes.length > 1) {
                return d.abst + getFicha(d.id) + (d.id.startsWith("m") ?
                  "<hr><br>Las tendencias relacionadas fuertemente con esta megatendencia son:" :
                  "<hr><br>Las megatendencias relacionadas fuertemente con esta tendencia son:");
              } else {
                return d.abst + getFicha(d.id) + (d.id.startsWith("m") ?
                  "<hr><br>La tendencia relacionada fuertemente con esta megatendencia es:" :
                  "<hr><br>La megatendencia relacionada fuertemente con esta tendencia es:");
              }

            });
          } else if (band == 1) {
            resumen_nodo.html(function () {
              if (listaModerados.length > 1) {
                return d.abst + getFicha(d.id) + (d.id.startsWith("m") ?
                  "<hr><br>Las tendencias relacionadas moderadamente con esta megatendencia son:" :
                  "<hr><br>Las megatendencias relacionadas moderadamente con esta tendencia son:");
              } else if (listaModerados.length == 1) {
                return d.abst + getFicha(d.id) + (d.id.startsWith("m") ?
                  "<hr><br>La tendencia relacionada moderadamente con esta megatendencia es:" :
                  "<hr><br>La megatendencia relacionada moderadamente con esta tendencia es:");
              } else {
                return d.abst + getFicha(d.id) + (d.id.startsWith("m") ?
                  "<hr><br>No existe relación moderada ni fuerte con alguna tendencia" :
                  "<hr><br>No existe relación moderada ni fuerte con alguna megatendencia");
              }
            });
          }
          relacionados.html("<ul>" + listaHTML + "</ul>");
        }
      }

      function getFicha(id) {
        var buttonFicha = `
        <div class="col-12 doc-color-button">
                <div class="div-button-download">
                    <a href="../ficha/${id}" target="_blank" style="cursor: pointer;">
                        <strong class="">Ficha completa</strong>
                    </a>
                </div>
            </div>
        `
        return "<p/><p/>Lea más acerca de este tema aqui:<p/>"
          + buttonFicha;
      }

      function isValidArray(array) {
        return typeof array != "undefined" && array != null && array.length != null ? true : false;
      }

      function clearArray(array) {
        array.length = 0;
      }

      function wrap(text1) {
        text1.each(function () {
          let text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            width = 650,
            lineNumber = 0,
            lineHeight = 1.1, // ems
            x = text.attr("x"),
            y = text.attr("y"),
            dy = 1.1,
            tspan = text.text(null)
              .append("tspan")
              .attr("x", x)
              .attr("y", y)
              .attr("dy", dy + "em");
          while (word = words.pop()) { // Elimina el último de la matriz words y devuelve ese elemento
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan")
                .attr("x", x)
                .attr("y", y)
                .attr("dy", ++lineNumber * lineHeight + dy + "em")
                .text(word);
            }
          }
        });
      }
    }

    function legend(data) {
      var separador = svg.selectAll('separator')
        .data([1])
        .enter().append("line")
        .attr("class", "separator")
        .attr("x1", 20)
        .attr("y1", 690)
        .attr("x2", 680)
        .attr("y2", 690)
        .attr("stroke", "#9FACC4")
        .attr("stroke-width", 1);

      /* Leyenda - forma Megatendencia */
      var tituloForma = svg.selectAll('titleF')
        .data([1])
        .enter()
        .append("text")
        .attr("class", "titleF")
        .attr("x", 100)
        .attr("y", 720)
        .text("Leyenda");

      var formaNExt = d3.select('svg')
        .append("g")
        .selectAll("g")
        .data([1])
        .enter()
        .append("g")
        .attr("class", "polygonM")
        .attr("transform", "translate(60,740)");

      formaNExt.append("polygon")
        .attr("points", pointsNE)
        .attr("fill", getColorNExt)
        .attr("transform", "rotate(-90) scale(.4)");

      formaNExt.append('text')
        .attr('x', 15)
        .attr('y', 5)
        .text("Megatendencia")
        .attr('font-size', 10);

      /* Leyenda - forma Tendencia */
      var formaNCent = d3.select('svg')
        .append("g")
        .selectAll("g")
        .data([0])
        .enter()
        .append("g")
        .attr("class", "polygonR")
        .attr("transform", "translate(60,770)");

      formaNCent.append("polygon")
        .attr("points", pointsNC)
        .attr("fill", getColorNExt)
        .attr("transform", "scale(.7)");

      formaNCent.append('text')
        .attr('x', 15)
        .attr('y', 4)
        .text("Tendencia")
        .attr('font-size', 10);

      /* Leyenda - Temáticas */
      var tempTemat = [];
      self.tematicas.forEach(function (d, i) {
        if (d.level != 15) {
          tempTemat.push(d)
        }
      })
      var mid = Math.round(tempTemat.length / 2); // mitad de temáticas

      var tituloTem = svg.selectAll('titleR')
        .data([0])
        .enter()
        .append("text")
        .attr("class", "titleR")
        .attr("x", 250)
        .attr("y", 720)
        .text("Temáticas de las tendencias");

      var tem = d3.select('svg')
        .append("g")
        .selectAll("g")
        .data(tempTemat)
        .enter()
        .append('g')
        .attr('class', 'legend')
        .attr('transform', function (d, i) {
          var height = 18, // espaciado
            x1 = 260, // 1ra columna
            x2 = 370, // 2da columna
            pos = 740; // posición inicial
          if (mid > i) {
            var y = i * height + pos;
            return 'translate(' + x1 + ',' + y + ')';
          } else {
            var y = (i - mid) * height + pos;
            return 'translate(' + x2 + ',' + y + ')';
          }
        });

      tem.append('polygon')
        .attr('points', pointsNC)
        .style('fill', function (d) {
          return d.color;
        })
        .style('stroke', 'none')
        .attr("transform", "scale(.7)");

      tem.append('text')
        .attr('x', 15)
        .attr('y', 4)
        .text(function (d) { return d.name; })
        .attr('font-size', 10);

      var tempTemat = [];

      /* Leyenda - Líneas */
      let lineasL = [
        { name: "Bajo", grosor: 0.2 },
        { name: "Moderado", grosor: 0.7 },
        { name: "Fuerte", grosor: 1.5 }
      ]

      var tituloLineas = svg.selectAll('titleL')
        .data([0])
        .enter()
        .append("text")
        .attr("class", "titleF")
        .attr("x", 550)
        .attr("y", 720)
        .text("Nivel de relación");

      var lineas = d3.select('svg')
        .append("g")
        .selectAll("g")
        .data(lineasL)
        .enter()
        .append("g")
        .attr("class", "lineasL")
        .attr("transform", function (d, i) {
          var height = 18, // espaciado
            x = 570, // 1ra columna                      
            pos = 740, // posición inicial                                
            y = i * height + pos;
          return 'translate(' + x + ',' + y + ')';
        });

      lineas.append("polygon")
        .attr("points", "-15,0 15,0")
        .attr("fill", "none")
        .attr("stroke", "black")
        .attr("stroke-width", function (d) {
          return d.grosor;
        });

      lineas.append('text')
        .attr('x', 25)
        .attr('y', 4)
        .text(function (d) {
          return d.name;
        })
        .attr('font-size', 10);
      /*  Fin Leyenda - Líneas */

      function getColorNExt() {
        var color = "#FFFFFF";
        data.forEach(function (d) {
          if (d.level == 15) {
            color = d.color;
          }
        })
        return color;
      }
    }
    simulador(this.dataNodos);
    legend(this.tematicas);

  }

  svgToPng() {
    this.saveSvgAsPng(d3.select('svg').node(), 'mapaT-M.png', { scale: 2 });
  }

  svgAsPngUri(el, options, cb) {
    this.svgAsDataUri(el, options, function (uri) {
      var image = new Image();
      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        if (options && options.backgroundColor) {
          context.fillStyle = options.backgroundColor;
          context.fillRect(0, 0, canvas.width, canvas.height);
        }
        context.drawImage(image, 0, 0);
        var a = document.createElement('a'), png;
        try {
          png = canvas.toDataURL('image/png');
        } catch (e) {
          console.error(e);
        }
        cb(png);
      }
      image.src = uri;
    });
  }

  saveSvgAsPng(el, name, options) {
    options = options || {};
    this.svgAsPngUri(el, options, function (uri) {
      var a = document.createElement('a');
      a.download = name;
      a.href = uri;
      document.body.appendChild(a);
      a.addEventListener("click", function (e) {
        a.parentNode.removeChild(a);
      });
      a.click();
    });
  }

  doctype = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">';

  svgAsDataUri(el, options, cb) {
    options = options || {};
    options.scale = options.scale || 1;
    var xmlns = "http://www.w3.org/2000/xmlns/";

    this.inlineImages(el, function () {
      var outer = document.createElement("div");
      var clone = el.cloneNode(true);
      var width, height;
      if (el.tagName == 'svg') {
        width = options.width || this.getDimension(el, clone, 'width');
        height = options.height || this.getDimension(el, clone, 'height');
      } else if (el.getBBox) {
        var box = el.getBBox();
        width = box.x + box.width;
        height = box.y + box.height;
        clone.setAttribute('transform', clone.getAttribute('transform').replace(/translate\(.*?\)/, ''));

        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
        svg.appendChild(clone)
        clone = svg;
      } else {
        console.error('Attempted to render non-SVG element', el);
        return;
      }

      clone.setAttribute("version", "1.1");
      clone.setAttributeNS(xmlns, "xmlns", "http://www.w3.org/2000/svg");
      clone.setAttributeNS(xmlns, "xmlns:xlink", "http://www.w3.org/1999/xlink");
      clone.setAttribute("width", width * options.scale);
      clone.setAttribute("height", height * options.scale);
      clone.setAttribute("viewBox", [
        options.left || 0,
        options.top || 0,
        width,
        height
      ].join(" "));

      outer.appendChild(clone);

      var css = this.styles(el, options.selectorRemap);
      var s = document.createElement('style');
      s.setAttribute('type', 'text/css');
      s.innerHTML = "<![CDATA[\n" + css + "\n]]>";
      var defs = document.createElement('defs');
      defs.appendChild(s);
      clone.insertBefore(defs, clone.firstChild);

      let svg2 = this.doctype + outer.innerHTML;
      var uri = 'data:image/svg+xml;base64,' + window.btoa(this.reEncode(svg2));
      if (cb) {
        cb(uri);
      }
    });
  }
  isExternal(url) {
    return url && url.lastIndexOf('http', 0) == 0 && url.lastIndexOf(window.location.host) == -1;
  }

  inlineImages(el, callback) {
    var images = el.querySelectorAll('image');
    var left = images.length;
    if (left == 0) {
      callback();
    }
    for (var i = 0; i < images.length; i++) {
      (function (image) {
        var href = image.getAttributeNS("http://www.w3.org/1999/xlink", "href");
        if (href) {
          if (this.isExternal(href.value)) {
            console.warn("Cannot render embedded images linking to external hosts: " + href.value);
            return;
          }
        }
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var img = new Image();
        href = href || image.getAttribute('href');
        img.src = href;
        img.onload = function () {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          image.setAttributeNS("http://www.w3.org/1999/xlink", "href", canvas.toDataURL('image/png'));
          left--;
          if (left == 0) {
            callback();
          }
        }
        img.onerror = function () {
          console.log("Could not load " + href);
          left--;
          if (left == 0) {
            callback();
          }
        }
      })(images[i]);
    }
  }

  getDimension(el, clone, dim) {
    var v = (el.viewBox && el.viewBox.baseVal && el.viewBox.baseVal[dim]) ||
      (clone.getAttribute(dim) !== null && !clone.getAttribute(dim).match(/%$/) && parseInt(clone.getAttribute(dim))) ||
      el.getBoundingClientRect()[dim] ||
      parseInt(clone.style[dim]) ||
      parseInt(window.getComputedStyle(el).getPropertyValue(dim));
    return (typeof v === 'undefined' || v === null || isNaN(parseFloat(v))) ? 0 : v;
  }
}
